import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

function OpenRequests({ requests }) {
    ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

    const colors = [
        {
            borderColor: 'rgb(0, 0, 255)',
            backgroundColor: 'rgba(0, 0, 255, 0.3)',
        },
        {
            borderColor: 'rgb(0, 255, 0)',
            backgroundColor: 'rgba(0, 255, 0, 0.3)',
        },
        {
            borderColor: 'rgb(255, 0, 0)',
            backgroundColor: 'rgba(255, 0, 0, 0.3)',
        },
        {
            borderColor: 'rgb(255, 0, 255)',
            backgroundColor: 'rgba(255, 0, 255, 0.3)',
        },
    ];

    let unique = (a) => [...new Set(a)];
    const labels = unique(requests.map((x) => x.AC));
    const datasetsType = unique(requests.map((x) => x.Type));
    //   console.log(datasetsType);

    let totalOpenRequests = requests.filter((x) => x.Status === 'Open').length;

    const datasets = datasetsType.map((ds, seq) => ({
        data: labels.map((l, i) => requests.filter((x) => x.AC === labels[i] && x.Status === 'Open' && x.Type === ds).length),
        // barThickness: 20,
        borderColor: colors[seq].borderColor,
        backgroundColor: colors[seq].backgroundColor,
        label: ds,
    }));

    const data = {
        labels,
        datasets,
    };

    //   console.log(data.datasets[0].data);

    const options = {
        indexAxis: 'y',
        elements: {
            bar: {
                borderWidth: 2,
            },
        },
        layout: {
            padding: 0,
            // height: 550
        },
        responsive: true,
        plugins: {
            legend: {
                display: true,
                // position: 'right',
            },
            //   title: {
            //     display: true,
            //     text: `Open Requests (${totalOpenRequests})`,
            //   },
        },
    };

    return (
        <div>
            <p>{`Open Requests (${totalOpenRequests})`}</p>
            <Bar options={options} data={data} />
        </div>
    );
}

export default OpenRequests;
